import { useState } from "react";
import { useSelector } from "react-redux";
import { useAddTeamMutation, useGetTeamsQuery } from "../../features/teams/teamsApi";
import Error from "../ui/Error";

export default function AddTeamModal({ open, control }) {
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [color, setColor] = useState("");
    const [teamsCheck, setTeamsCheck] = useState([]);
    const [addTeam] = useAddTeamMutation();
    const { user: loggedInUser } = useSelector((state) => state.auth) || {};
    const {data: teams} = useGetTeamsQuery();


    const handleSubmit = (e) => {
        e.preventDefault();

        if(teamsCheck?.length > 0) {
            return;
        }
        else if(name === "" || description === "" || color === "") {
            return;
        }
        addTeam({
            data: {
                name,
                description,
                color,
                users: [loggedInUser],
                timestamp: new Date().getTime(),
            },
        });
        setName("");
        setDescription("");
        setColor("");
        control();
    };

    const handleSearch = value => {
        setName(value);
        const foundUsers = teams.filter(team => team.name.toLowerCase() === value.toLowerCase());
        setTeamsCheck(foundUsers);
    };

    return (
        open && (
            <>
                <div
                    onClick={control}
                    className="fixed w-full h-full inset-0 z-10 bg-black/50 cursor-pointer"
                ></div>
                <div className="rounded w-[400px] lg:w-[600px] space-y-8 bg-white p-10 absolute top-1/2 left-1/2 z-20 -translate-x-1/2 -translate-y-1/2">
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                        Add Team
                    </h2>
                    <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
                        <div className="rounded-md shadow-sm -space-y-px">
                            <div>
                                <label htmlFor="to" className="sr-only">
                                    Team Name
                                </label>
                                <input
                                    id="team_name"
                                    name="team_name"
                                    type="text"
                                    required
                                    className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                                    placeholder="Team Name"
                                    onChange={(e) =>
                                        handleSearch(e.target.value)
                                    }
                                />
                            </div>
                            <div>
                                <label htmlFor="description" className="sr-only">
                                    Description
                                </label>
                                <textarea
                                    id="description"
                                    name="description"
                                    type="text"
                                    required
                                    className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm mt-2"
                                    placeholder="Description"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                            </div>
                            <div>
                                <select className="form-select appearance-none
                                    block
                                    w-full
                                    px-3
                                    py-1.5
                                    text-base
                                    font-normal
                                    text-gray-700
                                    bg-white bg-clip-padding bg-no-repeat
                                    border border-solid border-gray-300
                                    rounded
                                    transition
                                    ease-in-out
                                    mt-2
                                    focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" aria-label="Default select example"
                                    defaultValue={color}
                                    onChange={e => setColor(e.target.value)}
                                >
                                    <option value = "">Select Color</option>
                                    <option value="blue">Blue</option>
                                    <option value="green">Green</option>
                                    <option value="red">Red</option>
                                    <option value="gray">Gray</option>
                                    <option value="yellow">Yellow</option>
                                    <option value="pink">Pink</option>
                                </select>
                            </div>
                        </div>

                        <div>
                            <button
                                type="submit"
                                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
                            >
                                Add Team
                            </button>
                        </div>
                        {teamsCheck?.length > 0 && (
                            <Error message="This Team already exists!" />
                        )}
                    </form>
                </div>
            </>
        )
    );
}
